// frontend/src/utils/companyProfile.js
// Perfil de empresa del emisor (GET/PUT /api/settings/company-profile).
// Caché simple en módulo: el perfil cambia poco; `invalidate` tras guardar.
import { apiFetch, API } from "@/utils/api";

let _cache = null;
let _pending = null;

export async function getCompanyProfile({ force = false } = {}) {
  if (_cache && !force) return _cache;
  if (_pending && !force) return _pending;
  _pending = apiFetch(`${API}/settings/company-profile`)
    .then(async (r) => {
      if (!r.ok) throw new Error("No se pudo cargar el perfil de empresa");
      _cache = await r.json();
      return _cache;
    })
    .finally(() => {
      _pending = null;
    });
  return _pending;
}

export async function updateCompanyProfile(partial) {
  const r = await apiFetch(`${API}/settings/company-profile`, {
    method: "PUT",
    body: JSON.stringify(partial),
  });
  if (!r.ok) {
    const err = await r.json().catch(() => ({}));
    throw new Error(err.detail || "No se pudo guardar el perfil");
  }
  _cache = await r.json();
  return _cache;
}

export function invalidateCompanyProfile() {
  _cache = null;
}

// Defaults fiscales para formularios de factura. `??` (no ||): 0 es legítimo.
export async function getInvoiceDefaults() {
  try {
    const p = await getCompanyProfile();
    return {
      // Régimen exento (art. 20): IVA 0 siempre, independientemente de iva_default
      vat_rate:
        p?.fiscal_facturas?.regimen_iva === "exento"
          ? 0
          : (p?.fiscal_facturas?.iva_default ?? 21),
      irpf_rate: p?.fiscal_facturas?.aplicar_irpf_default
        ? (p?.fiscal_facturas?.irpf_default ?? 0)
        : 0,
    };
  } catch {
    return { vat_rate: 21, irpf_rate: 0 }; // mismo comportamiento que hoy si el perfil no carga
  }
}
